// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDeliveryDate = deliveryDateRange => ({
    deliveryDateRange,
    type: actions.UPDATE_REGISTRATIONS_REVIEW_DELIVERY_DATE
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/update-delivery-date.js